// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-blog-post-js": require("gatsby-module-loader?name=component---src-templates-blog-post-js!/opt/build/repo/src/templates/blog-post.js"),
  "component---src-pages-index-js": require("gatsby-module-loader?name=component---src-pages-index-js!/opt/build/repo/src/pages/index.js"),
  "component---src-pages-new-page-js": require("gatsby-module-loader?name=component---src-pages-new-page-js!/opt/build/repo/src/pages/new-page.js")
}

exports.json = {
  "layout-index.json": require("gatsby-module-loader?name=path---!/opt/build/repo/.cache/json/layout-index.json"),
  "hello-world.json": require("gatsby-module-loader?name=path---hello-world!/opt/build/repo/.cache/json/hello-world.json"),
  "my-second-post.json": require("gatsby-module-loader?name=path---my-second-post!/opt/build/repo/.cache/json/my-second-post.json"),
  "hi-folks.json": require("gatsby-module-loader?name=path---hi-folks!/opt/build/repo/.cache/json/hi-folks.json"),
  "index.json": require("gatsby-module-loader?name=path---index!/opt/build/repo/.cache/json/index.json"),
  "new-page.json": require("gatsby-module-loader?name=path---new-page!/opt/build/repo/.cache/json/new-page.json")
}

exports.layouts = {
  "layout---index": require("gatsby-module-loader?name=component---src-layouts-index-js!/opt/build/repo/.cache/layouts/index.js")
}


// WEBPACK FOOTER //
// ./.cache/async-requires.js